module.exports = __webpack_public_path__ + "static/clubhouse-0c2e9fab8c22029f3b571b198d5f4804.png";